import React, { useEffect, useRef } from 'react'

const ParticleCanvas = () => {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const wrapper = canvas.parentElement
    const ctx = canvas.getContext('2d')
    const colors = ['#f472b6','#60a5fa','#34d399','#a78bfa','#fb923c','#facc15','#f87171']
    let animId
    let particles = []

    const resize = () => {
      canvas.width = wrapper.offsetWidth
      canvas.height = wrapper.offsetHeight
    }

    const rand = (a, b) => a + Math.random() * (b - a)

    const newParticle = (randomY = false) => ({
      x: rand(0, canvas.width),
      y: randomY ? rand(0, canvas.height) : rand(-20, 0),
      r: rand(3, 7),
      color: colors[Math.floor(Math.random() * colors.length)],
      vy: rand(0.6, 1.8),
      vx: rand(-0.4, 0.4),
      alpha: rand(0.6, 1),
    })

    const init = () => {
      resize()
      particles = Array.from({ length: 38 }, () => newParticle(true))
    }

    const animate = () => { 
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      particles.forEach((p, i) => {
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fillStyle = p.color
        ctx.globalAlpha = p.alpha
        ctx.fill()
        p.y += p.vy
        p.x += p.vx
        if (p.y > canvas.height + 10) particles[i] = newParticle(false)
      })
      ctx.globalAlpha = 1
      animId = requestAnimationFrame(animate)
    }

    init()
    animate()
    window.addEventListener('resize', resize)
    return () => {
      cancelAnimationFrame(animId)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}
    />
  )
}

export default ParticleCanvas
